// extracted by mini-css-extract-plugin
export default {"highlightWrapper":"TextWithHighlight__highlightWrapper-JomF","highlight":"TextWithHighlight__highlight-m5Yn"};